import {
  AfterViewInit,
  Component,
  OnInit,
  ViewChild,
  inject
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { OpenPresetDialogComponent } from "@app/view/data-view/open-preset-dialog/open-preset-dialog.component";
import { NewPresetDialogComponent } from "@app/view/data-view/new-preset-dialog/new-preset-dialog.component";
import { SavePresetDialogComponent } from "@app/view/data-view/save-preset-dialog/save-preset-dialog.component";
import { SystemSearchPresetRestService } from "@app/services/hal/system-search-preset-rest.service";
import { JobTableViewerComponent } from "@app/view/data-view/job-table-viewer/job-table-viewer.component";
import { SystemSearchPreset } from "@app/models/rest/system-search-preset";
import { VisitTableViewerComponent } from "@app/view/data-view/visit-table-viewer/visit-table-viewer.component";
import { DeletePresetDialogComponent } from "@app/view/data-view/delete-preset-dialog/delete-preset-dialog.component";
import { TicketTableViewerComponent } from "@app/view/data-view/ticket-table-viewer/ticket-table-viewer.component";
import { MeetingTableViewerComponent } from "@app/view/data-view/meeting-table-viewer/meeting-table-viewer.component";
import { MatToolbar } from "@angular/material/toolbar";
import { MatIconButton, MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { MatTooltip } from "@angular/material/tooltip";
import { MatMenuTrigger, MatMenu, MatMenuItem } from "@angular/material/menu";
import { JobTableViewerComponent as JobTableViewerComponent_1 } from "../job-table-viewer/job-table-viewer.component";
import { MeetingTableViewerComponent as MeetingTableViewerComponent_1 } from "../meeting-table-viewer/meeting-table-viewer.component";
import { VisitTableViewerComponent as VisitTableViewerComponent_1 } from "../visit-table-viewer/visit-table-viewer.component";
import { TicketTableViewerComponent as TicketTableViewerComponent_1 } from "../ticket-table-viewer/ticket-table-viewer.component";
import { MatActionList, MatListItem } from "@angular/material/list";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-preset-manager",
  templateUrl: "./preset-manager.component.html",
  styleUrls: ["./preset-manager.component.scss"],
  imports: [
    MatToolbar,
    MatIconButton,
    MatButton,
    MatIcon,
    MatTooltip,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    JobTableViewerComponent_1,
    MeetingTableViewerComponent_1,
    VisitTableViewerComponent_1,
    TicketTableViewerComponent_1,
    MatActionList,
    MatListItem,
    MatSlideToggle,
    FormsModule
  ]
})
export class PresetManagerComponent implements OnInit, AfterViewInit {
  private activeRoute = inject(ActivatedRoute);
  router = inject(Router);
  systemSearchPresetRestService = inject(SystemSearchPresetRestService);
  protected dialog = inject(MatDialog);

  @ViewChild("jobTableViewer", { static: false })
  jobTableViewer: JobTableViewerComponent;
  @ViewChild("meetingTableViewer", { static: false })
  meetingTableViewer: MeetingTableViewerComponent;
  @ViewChild("visitTableViewer", { static: false })
  visitTableViewer: VisitTableViewerComponent;
  @ViewChild("ticketTableViewer", { static: false })
  ticketTableViewer: TicketTableViewerComponent;

  isNew: boolean = false;
  isSaveable: boolean = false;
  isSaveAsable: boolean = false;
  isDeleteable: boolean = false;
  isExportable: boolean = false;
  needsUpgrade: boolean = false;
  activeEntity: string;
  activeTemplateName: string = "Data Viewer";
  available: SystemSearchPreset[] = [];
  loadedAvailablePresets = false;
  private activeId: number;
  private activePreset: SystemSearchPreset;

  ngAfterViewInit(): void {
    this.systemSearchPresetRestService
      .getPage({
        params: { projection: "list" },
        pageParams: { size: 500 },
        sort: { searchName: "ASC" }
      })
      .subscribe((value) => {
        this.available = value.resources;
        this.loadedAvailablePresets = true;
      });
  }

  ngOnInit() {
    const me = this;
    console.log("Active route", this.activeRoute);

    // Subscribe to query parameters instead of route params
    this.activeRoute.queryParams.subscribe((value) => {
      console.log("Active query params changed", value);
      if (value.v) {
        me.activeEntity = value.v;
        me.activeTemplateName = "Unsaved View";
        me.isSaveAsable = true;
        me.isExportable = true;
        me.needsUpgrade = false;
        setTimeout(() => {
          if (!value.i) {
            switch (me.activeEntity) {
              case "Job":
                console.log("loading job");
                this.isNew = true;
                me.jobTableViewer.restoreState(
                  JSON.stringify({
                    columns: me.jobTableViewer.columns
                  })
                );
                me.jobTableViewer.grid.store.performFilter(false);
                break;
              case "Meeting":
                console.log("loading meeting");
                this.isNew = true;
                me.meetingTableViewer.restoreState(
                  JSON.stringify({
                    columns: me.meetingTableViewer.columns
                  })
                );
                me.meetingTableViewer.grid.store.performFilter(false);
                break;
              case "Visit":
                console.log("loading visit");
                this.isNew = true;
                me.visitTableViewer.restoreState(
                  JSON.stringify({
                    columns: me.visitTableViewer.columns
                  })
                );
                me.visitTableViewer.grid.store.performFilter(false);
                break;
              case "Ticket":
                console.log("loading ticket");
                this.isNew = true;
                me.ticketTableViewer.restoreState(
                  JSON.stringify({
                    columns: me.ticketTableViewer.columns
                  })
                );
                me.ticketTableViewer.grid.store.performFilter(false);
                break;
            }
          }
        }, 100);
      } else {
        this.activeEntity = null;
        this.activeTemplateName = "Data Viewer";
        this.isDeleteable = false;
        this.isSaveable = false;
        this.isSaveAsable = false;
        this.isExportable = false;
        this.needsUpgrade = false;
        this.ngAfterViewInit();
      }
      console.log("query param: ", value);
      if (value.i) {
        this.activeTemplateName = "Loading..";
        this.isSaveAsable = false;
        this.activeId = value.i;
        this.systemSearchPresetRestService
          .getResource(value.i)
          .subscribe((preset) => {
            console.log("loaded preset " + preset);
            this.activeTemplateName = preset.searchName;
            this.activePreset = preset;
            const stateData = JSON.parse(preset.jsonData);
            console.log("Restored stateData", stateData);
            this.isSaveAsable = true;
            this.isDeleteable = true;
            if (!preset.upgraded) {
              this.needsUpgrade = true;
              this.isSaveable = true;
            }
            switch (preset.entityName) {
              case "Job":
                if (preset.upgraded) {
                  this.jobTableViewer.restoreState(preset.jsonData);
                } else {
                  this.jobTableViewer.restoreStateLegacy(preset.jsonData);
                }
                const jobFilterAction = this.jobTableViewer.grid.store.filter(
                  stateData.filters
                );
                if (jobFilterAction) {
                  jobFilterAction.then(() => {
                    if (!this.needsUpgrade) {
                      this.isSaveable = false;
                    }
                  });
                } else {
                  this.jobTableViewer.grid.store.load({});
                  if (!this.needsUpgrade) {
                    this.isSaveable = false;
                  }
                }
                break;
              case "Visit":
                if (preset.upgraded) {
                  this.visitTableViewer.restoreState(preset.jsonData);
                } else {
                  this.visitTableViewer.restoreStateLegacy(preset.jsonData);
                }
                const visitFilterAction =
                  this.visitTableViewer.grid.store.filter(stateData.filters);
                if (visitFilterAction) {
                  visitFilterAction.then(() => {
                    if (!this.needsUpgrade) {
                      this.isSaveable = false;
                    }
                  });
                } else {
                  this.visitTableViewer.grid.store.load({});
                  if (!this.needsUpgrade) {
                    this.isSaveable = false;
                  }
                }
                break;
              case "Ticket":
                if (preset.upgraded) {
                  this.ticketTableViewer.restoreState(preset.jsonData);
                } else {
                  this.ticketTableViewer.restoreStateLegacy(preset.jsonData);
                }
                const filterAction = this.ticketTableViewer.grid.store.filter(
                  stateData.filters
                );
                if (filterAction) {
                  filterAction.then(() => {
                    if (!this.needsUpgrade) {
                      this.isSaveable = false;
                    }
                  });
                } else {
                  this.ticketTableViewer.grid.store.load({});
                  if (!this.needsUpgrade) {
                    this.isSaveable = false;
                  }
                }

                break;
            }
          });
      }
    });
  }

  openDialog() {
    let ref = this.dialog.open(OpenPresetDialogComponent, {
      width: "500px"
    });
    ref.afterClosed().subscribe((value) => {
      this.router.navigate(["view"], {
        queryParams: { v: value.entityName, i: value.id }
      });
    });
  }

  newDialog() {
    let ref = this.dialog.open(NewPresetDialogComponent, {});
    ref.afterClosed().subscribe((value) => {
      console.log("closed", value);
      if (value.entity) {
        console.log("selected" + value.entity);
        this.router.navigate(["view"], { queryParams: { v: value.entity } });
        this.isNew = true;
      }
    });
  }

  savePreset() {
    let state = "";
    switch (this.activeEntity) {
      case "Job":
        state = this.jobTableViewer.persistState();
        break;
      case "Visit":
        state = this.visitTableViewer.persistState();
        break;
      case "Ticket":
        state = this.ticketTableViewer.persistState();
        break;
    }
    this.activePreset.jsonData = state;
    this.activePreset.upgraded = true;
    this.systemSearchPresetRestService
      .patchResource(this.activePreset)
      .subscribe(() => {
        this.isSaveable = false;
      });
  }

  savePresetAs() {
    let state = "";
    switch (this.activeEntity) {
      case "Job":
        state = this.jobTableViewer.persistState();
        break;
      case "Visit":
        state = this.visitTableViewer.persistState();
        break;
      case "Ticket":
        state = this.ticketTableViewer.persistState();
        break;
    }

    console.log(state);
    let dialogRef = this.dialog.open(SavePresetDialogComponent, {});
    dialogRef.afterClosed().subscribe((value) => {
      console.log("save request", value);
      if (value.name) {
        let preset: SystemSearchPreset = new SystemSearchPreset();
        preset.entityName = this.activeEntity;
        preset.jsonData = state;
        preset.searchName = value.name;
        preset.upgraded = true;
        this.systemSearchPresetRestService
          .createResource({ body: preset })
          .subscribe((saved: SystemSearchPreset) => {
            this.isNew = false;
            this.router.navigate(["view"], {
              queryParams: { v: preset.entityName, i: saved.id }
            });
          });
      }
    });
  }

  deleteDialog() {
    let dialogRef = this.dialog.open(DeletePresetDialogComponent, {
      data: {
        id: this.activeId
      }
    });
    dialogRef.afterClosed().subscribe((value) => {
      if (value.confirm) {
        this.systemSearchPresetRestService
          .getResource(value.id)
          .subscribe((value1) => {
            this.systemSearchPresetRestService
              .deleteResource(value1)
              .subscribe(() => {
                this.router.navigate(["view"]);
              });
          });
      }
    });
  }

  gridChanged() {
    if (!this.isNew) {
      this.isSaveable = true;
    }
  }

  refreshData() {
    switch (this.activeEntity) {
      case "Job":
        this.jobTableViewer.grid.store.load({});
        break;
      case "Visit":
        console.log("loading visit");
        this.visitTableViewer.grid.store.load({});
        break;
      case "Ticket":
        console.log("loading ticket");
        this.ticketTableViewer.grid.store.load({});
        break;
      default:
        this.ngAfterViewInit();
        break;
    }
  }

  selectView(id: number, entityName: string) {
    this.router.navigate(["view"], { queryParams: { v: entityName, i: id } });
  }

  exportToExcel() {
    switch (this.activeEntity) {
      case "Job":
        this.jobTableViewer.grid.gridEngine.features.excelExporter
          .export({
            filename: this.activePreset.searchName
          })
          .then();
        break;
      case "Visit":
        this.visitTableViewer.grid.gridEngine.features.excelExporter
          .export({
            filename: this.activePreset.searchName
          })
          .then();
        break;
      case "Ticket":
        this.ticketTableViewer.grid.gridEngine.features.excelExporter
          .export({
            filename: this.activePreset.searchName
          })
          .then();
        break;
      case "Meeting":
        this.meetingTableViewer.grid.gridEngine.features.excelExporter
          .export({
            filename: this.activePreset.searchName
          })
          .then();
        break;
    }
  }
}
